module.exports = __webpack_public_path__ + "img/title1.b98eda1c.png";